import { Modal } from "react-bootstrap";
import { useState, useRef } from "react";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { CompanyBanner, ProfileGet } from "../../apis/api/ProfileApi";
import Cookies from "js-cookie";

const EditcoverPhoto = ({ show, handleClose }) => {
  const dispatch = useDispatch();

  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);
  const cropperRef = useRef(null);

  const userId = Cookies.get("userID");
  const company_id = Cookies.get("company_id");

  // Handle file selection
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  // Handle drag & drop file selection
  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFile = e.dataTransfer.files[0];
    if (droppedFile) {
      setFile(droppedFile);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(droppedFile);
    }
  };

  // Remove selected file
  const removeFile = () => {
    setFile(null);
    setPreview(null);
    setCroppedImage(null);
  };

  // Crop Image
  const handleCrop = () => {
    if (cropperRef.current) {
      const croppedCanvas = cropperRef.current.cropper.getCroppedCanvas();
      if (croppedCanvas) {
        setCroppedImage(croppedCanvas.toDataURL());
      }
    }
  };

  // Handle file upload
  const handleUpload = async () => {
    if (!croppedImage) {
      toast.error("Please Crop the Image");
    }

    const blob = await fetch(croppedImage).then((res) => res.blob());
    const urlParts = croppedImage.split("/");
    const filename = urlParts[urlParts.length - 1] || "image.jpg";

    const formData = new FormData();
    formData.append("userId", userId);
    formData.append("company_id", company_id);
    formData.append("file", blob, filename);

    const response = await dispatch(CompanyBanner(formData));

    if (response.payload.status == "success") {
      const profile_update = await dispatch(ProfileGet({ userId, company_id }));
      if (profile_update.payload.status == "success") {
        removeFile();
        handleClose();
        toast.success("Company Banner Updated Successfully!");
      } else {
        removeFile();
        handleClose();
        toast.error("Error");
      }
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="md" centered>
      <Modal.Header closeButton>
        <Modal.Title>Upload Cover Photo</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="container py-3">
          {/* Drag & Drop Upload Box (Hidden when file is selected) */}
          {!file && (
            <div
              className="file-upload-wrapper border rounded p-4 text-center"
              onDragOver={(e) => e.preventDefault()}
              onDrop={handleDrop}
            >
              <label className="file-upload-box w-100 d-block">
                <input
                  type="file"
                  className="d-none"
                  onChange={handleFileChange}
                  accept="image/*"
                />
                <div className="upload-content">
                  <i className="bx bx-cloud-upload upload-icon bx-3x text-primary"></i>
                  <h5 className="mb-2">Drag & Drop a file here</h5>
                  <p className="text-muted mb-0">or click to browse</p>
                </div>
              </label>
            </div>
          )}

          {/* Image Cropper Section */}
          {preview && (
            <div className="mt-3 text-center">
              <Cropper
                src={preview}
                style={{ height: 200, width: "100%" }}
                aspectRatio={16 / 5} // Adjust aspect ratio for cover photos
                guides={false}
                ref={cropperRef}
              />
              <button
                className="btn btn-sm btn-primary mt-2"
                onClick={handleCrop}
              >
                Crop Image
              </button>
            </div>
          )}

          {/* Cropped Image Preview */}
          {croppedImage && (
            <div className="file-preview mt-4 p-3 border rounded bg-light text-center">
              <img
                src={croppedImage}
                alt="Cropped Preview"
                className="img-fluid rounded mb-2"
                style={{ maxHeight: "200px", objectFit: "cover" }}
              />
              <button
                className="btn btn-sm btn-danger mt-2"
                onClick={removeFile}
                style={{
                  borderRadius: "50%",
                  width: "30px",
                  height: "30px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <i className="bx bx-x"></i>
              </button>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={handleClose}>
          Cancel
        </button>
        <button
          className="btn btn-primary"
          onClick={handleUpload}
          disabled={!croppedImage}
        >
          Upload
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditcoverPhoto;
